import apiService from '@/utils/api-client'
import { sendFormatter } from "@/utils/text-formatter";
import analytics from "@/store/modules/analytics";
import appConfig from '@/utils/appConfig'
import { featureAccess } from '@/utils/accesses'

/**
 * Вспомогательная функция для определения baseURL.
 * Приоритет: явный параметр > MULTI_LABELING API > системный дефолт.
 */
const getFinalBaseUrl = (explicitUrl) => {
  if (explicitUrl) {
    return explicitUrl;
  }

  if (featureAccess('MULTI_LABELING')) {
    return appConfig.VUE_APP_WALLET_LABEL_API_URL;
  }

  return null;
};

export default {
  // eslint-disable-next-line no-unused-vars
  async getTypes({ commit }, { baseUrl, ...params }) {
    const path = featureAccess('MULTI_LABELING') ? '/labeling/getTypes' : 'getTypes'
    const fallback = featureAccess('MULTI_LABELING')
      ? analytics.state.coinData.profilesServiceUrl
      : null

    const finalBaseUrl = baseUrl ||
      (featureAccess('MULTI_LABELING') ? appConfig.VUE_APP_LABEL_API_URL : fallback)

    const finalParams = {
      count: 1000,
      ...params
    }

    try {
      const data = await apiService.get(path, {
        params: finalParams,
        baseURL: finalBaseUrl
      })
      return data
    } catch (error) {
      console.error(error)
    }
  },

  // eslint-disable-next-line no-unused-vars
  async addType({ commit }, { baseUrl, ...data }) {
    if (data.name) {
      data.name = sendFormatter(data.name);
    }

    try {
      return await apiService.post(`addType`, data, {
        baseURL: getFinalBaseUrl(baseUrl)
      });
    } catch (error) {
      console.error(error);
    }
  },

  // eslint-disable-next-line no-unused-vars
  async mergeTypes({ commit }, { baseUrl, toType, fromTypes, score, skipCheck = false }) {
    const formattedToType = sendFormatter(toType);
    const formattedFromType = fromTypes.map(type => sendFormatter(type));

    const payload = {
      toType: formattedToType,
      fromTypes: formattedFromType,
      score,
      skipCheck
    };

    try {
      return await apiService.post(`mergeTypes`, payload, {
        baseURL: getFinalBaseUrl(baseUrl)
      });
    } catch (error) {
      console.error(error);
    }
  },

  // eslint-disable-next-line no-unused-vars
  async editType({ commit }, { baseUrl, isScoringPage = false, ...params }) {
    const { name, newName, ...rest } = params

    const formattedName = sendFormatter(name)
    const formattedNewName = sendFormatter(newName)

    const isMulti = featureAccess('MULTI_LABELING')

    const path = isMulti
      ? (isScoringPage ? '/wallet-labeling/editType' : '/labeling/editType')
      : 'editType'

    const fallback = isMulti ? undefined : analytics.state.coinData.baseUrl

    const finalBaseUrl = baseUrl ||
      (isMulti ? appConfig.VUE_APP_LABEL_API_URL : fallback)

    const payload = {
      ...rest,
      name: formattedName,
      newName: formattedNewName
    }

    try {
      const data = await apiService.post(path, payload, {
        baseURL: finalBaseUrl
      })
      return data
    } catch (error) {
      console.error(error)
    }
  },

  async deleteType(ctx, { names, ids, skipCheck, baseUrl }) {
    const formattedNames = names
      ? names.map(name => sendFormatter(name))
      : [];

    try {
      return await apiService.delete(`deleteType`, {
        data: {
          names: formattedNames,
          ids,
          skipCheck
        },
        baseURL: getFinalBaseUrl(baseUrl)
      });
    } catch (error) {
      console.error(error);
    }
  },

  // eslint-disable-next-line no-unused-vars
  async resetScoreType({ commit }, { baseUrl, ...params }) {
    const path = featureAccess('MULTI_LABELING') ? '/labeling/resetScoreType' : 'resetScoreType'
    const fallback = featureAccess('MULTI_LABELING') ? undefined : analytics.state.coinData.profilesServiceUrl
    const finalBaseUrl = baseUrl ||
      (featureAccess('MULTI_LABELING') ? appConfig.VUE_APP_LABEL_API_URL : fallback)

    const payload = {
      ...params
    }

    try {
      const data = await apiService.post(path, payload, {
        baseURL: finalBaseUrl
      })
      return data
    } catch (error) {
      console.error(error)
    }
  },

  // eslint-disable-next-line no-unused-vars
  async resetScoreTag({ commit }, { baseUrl, ...params }) {
    const path = featureAccess('MULTI_LABELING') ? '/labeling/resetScoreTag' : 'resetScoreTag'
    const fallback = featureAccess('MULTI_LABELING') ? undefined : analytics.state.coinData.profilesServiceUrl
    const finalBaseUrl = baseUrl ||
      (featureAccess('MULTI_LABELING') ? appConfig.VUE_APP_LABEL_API_URL : fallback)

    const payload = {
      ...params
    }

    try {
      const data = await apiService.post(path, payload, {
        baseURL: finalBaseUrl
      })
      return data
    } catch (error) {
      console.error(error)
    }
  },
}
